const timestampKey = "whoForSetAt";
const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;

export function recordWhoForSuppression(): void {
	try {
		localStorage.setItem(timestampKey, String(Date.now()));
	} catch {
		// localStorage unavailable — suppression simply won't persist
	}
}

export function isWhoForSuppressed(): boolean {
	try {
		const raw = localStorage.getItem(timestampKey);
		if (!raw) return false;
		return Date.now() - Number(raw) <= sevenDaysMs;
	} catch {
		return false;
	}
}
